// 1. Import the utilities
// 2. Update the breakpoints as key-value pairs
export const breakpoints = {
  sm: '320px',
  md: '768px',
  lg: '960px',
  xl: '1200px',
  '2xl': '1536px'
};
